import { createContext, RefObject } from "react";

export const GaiaMapContext = createContext<{
    isMapLoaded: boolean;
    mapRef?: RefObject<mapboxgl.Map | null>;
}>({
    isMapLoaded: false,
});
